(function() {
    'use strict';

    angular
        .module('portalApp')
        .controller('TimeseriesDetailController', TimeseriesDetailController);

    TimeseriesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'Timeseries', 'Country', 'Frequency', 'TimeseriesData'];

    function TimeseriesDetailController($scope, $rootScope, $stateParams, entity, Timeseries, Country, Frequency, TimeseriesData) {
        var vm = this;

        vm.timeseries = entity;

        var unsubscribe = $rootScope.$on('portalApp:timeseriesUpdate', function(event, result) {
            vm.timeseries = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
